import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  template: `
    <table>
      <thead>
        <tr>
          <th>ValType</th>
          <th>Col/Uni</th>
          <th>MaxMarks</th>
          <th>Sections</th>
          <th>SectionMarks</th>
          <th>PassMarks</th>
          <th>ExmMarks</th>
          <th>DistMarks</th>
          <!-- Add more columns as needed -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data">
          <td>{{ row.column1 }}</td>
          <td>{{ row.column2 }}</td>
          <td>{{ row.column3 }}</td>
          <td>{{ row.column4 }}</td>
          <td>{{ row.column5 }}</td>
          <td>{{ row.column6 }}</td>
          <td>{{ row.column7 }}</td>
          <td>{{ row.column8 }}</td>
          <!-- Add more cells based on the columns -->
        </tr>
      </tbody>
    </table>
  `,
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() data: any[] = [];
  constructor() { }

  ngOnInit(): void {
  }

}
